const setSelectedSession = (state, payload) => {
  state.selectedSession = payload
}

const setIsRenderedReport = (state, payload) => {
  state.isRenderedReport = payload
}

const setIsCreatingNewSession = (state, payload) => {
  state.isCreatingNewSession = payload
}

const setResettingResultsPresentationId = (state, payload) => {
  state.resettingResultsPresentationId = payload
}

export default {
  setSelectedSession,
  setIsRenderedReport,
  setIsCreatingNewSession,
  setResettingResultsPresentationId,
}
